var _rect, _g, _rect2, _line, _line2, _line3, _line4, _line5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAifStudyDrill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "#2b56c9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7 80 84)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 34,
    width: 92,
    height: 94,
    rx: 7,
    fill: "#fffdf8",
    opacity: 0.4
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 40,
    width: 108,
    height: 92,
    rx: 7,
    fill: "#fffdf8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 40,
    x2: 46,
    y2: 132,
    stroke: "#e0625a",
    strokeWidth: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 70,
    x2: 122,
    y2: 70,
    stroke: "#c8d6f0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 86,
    x2: 122,
    y2: 86,
    stroke: "#c8d6f0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 102,
    x2: 108,
    y2: 102,
    stroke: "#c8d6f0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 118,
    x2: 116,
    y2: 118,
    stroke: "#c8d6f0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAifStudyDrill);
export default __webpack_public_path__ + "static/media/AifStudyDrill.e7a8be729f3da6d3457a1c8c2e4f5fb3.svg";
export { ForwardRef as ReactComponent };